import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Typography,
  Skeleton
} from '@mui/material'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../../utils/utils'
import { Helmet } from 'react-helmet-async'
import MainCard, {
  ConfirmationDialog,
  CardCarousel,
  ModernCard,
  StatBox
} from '../../../utils/ui_utils'
import moment from 'moment'
import { BarChart } from '../../../components/Chart'
import Marquee from 'react-fast-marquee'
import {
  useFetchBusinessSumaryCurrentReport,
  useFetchBusinessSumaryReport,
  useFetchOutletSummaryForFranchise,
  useFetchOutletwiseSummary
} from '../../../modules/reports/reportsHooks'
import { useFetchEntitlement } from '../../../modules/entitlement/entitlementHooks'
import { useFetchUserById, useLogout } from '../../../modules/user/userHooks'
import { getUserType } from '../../../components/tsComponents/AuthGuard'
import { useDispatch } from 'react-redux'
import { useFetchBusinessById } from '../../../modules/business/businessHooks'
function Default() {
  const history = useNavigate()
  const { fetchEntitlement, fetchEntitlementData } = useFetchEntitlement()
  const {
    businessSummaryCurrentReportFetch: fetchCurrent,
    businessSummaryCurrentReportData: currentData,
    businessSummaryCurrentReportLoading: currentLoading
  } = useFetchBusinessSumaryCurrentReport()
  const {
    businessSummaryReportFetch: fetchWeekly,
    businessSummaryReportData: weeklyData,
    businessSummaryReportLoading: weeklyLoading
  } = useFetchBusinessSumaryReport()
  const {
    data: outletwiseSummaryData,
    fetch: outletwiseSummaryFetch,
    loading: outletwiseLoading
  } = useFetchOutletwiseSummary()
  const {
    data: franchiseSummaryData,
    fetch: franchiseSummaryFetch,
    loading: franchiseLoading
  } = useFetchOutletSummaryForFranchise()
  let fromDate = ''
  let toDate = ''
  const [isExpired, setIsExpired] = useState(null)
  const curDate = new Date()
  const { fetchBusinessByApplication } = useFetchBusinessById()
  const [currentDateData, setCurrentDateData] = useState([
    {
      Record_Date: moment().format('YYYY-MM-DD'),
      Total_Bills: 0,
      Total_Cess: 0.0,
      Total_Disc: 0.0,
      Total_GST: 0.0,
      Total_Sales: 0.0,
      Total_Qty: 0.0
    }
  ])
  const [dailySalesChartData, setdailySalesChartData] = useState({
    labels: [moment().format('MMM-DD')],
    datasets: [
      {
        label: 'Total Sales',
        data: [0],
        backgroundColor: ['#ffbb11']
      }
    ]
  })

  const [dailyBillsChartData, setdailyBillsChartData] = useState({
    labels: [moment().format('MMM-DD')],
    datasets: [
      {
        label: 'Total Invoices',
        data: [0],
        backgroundColor: ['#ffbb11']
      }
    ]
  })

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index'
    },
    scales: {
      x: {
        type: 'category',
        display: true,
        title: {
          display: true,
          text: 'Date'
        },
        grid: {
          display: true
        }
      },
      y: {
        beginAtZero: true,
        display: true,
        title: {
          display: true,
          text: 'Sales Amount'
        }
      }
    },
    plugins: {
      title: {
        display: true,
        text: 'Daily Sales Trend',
        padding: {
          top: 10,
          bottom: 30
        }
      },
      legend: {
        display: true,
        position: 'bottom'
      },
      datalabels: {
        display: true,
        color: 'black',
        formatter: Math.round,
        anchor: 'end',
        offset: -20,
        align: 'start'
      }
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderSkipped: false
      }
    },
    categoryPercentage: 0.8,
    barPercentage: 0.9
  }

  const chartOptionsForInvoice = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index'
    },
    scales: {
      x: {
        type: 'category',
        display: true,
        title: {
          display: true,
          text: 'Date'
        },
        grid: {
          display: true
        }
      },
      y: {
        beginAtZero: true,
        display: true,
        title: {
          display: true,
          text: 'Invoice Count'
        }
      }
    },
    plugins: {
      title: {
        display: true,
        text: 'Daily Invoices Trend',
        padding: {
          top: 10,
          bottom: 30
        }
      },
      legend: {
        display: true,
        position: 'bottom'
      },
      datalabels: {
        display: true,
        color: 'black',
        formatter: Math.round,
        anchor: 'end',
        offset: -20,
        align: 'start'
      }
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderSkipped: false
      }
    },
    categoryPercentage: 0.8,
    barPercentage: 0.9
  }

  const userType = getUserType()

  const chartOptionsForSubBusiness = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index'
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: true
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
          font: {
            size: 11
          }
        }
      },
      y: {
        beginAtZero: true,
        display: true,
        ticks: {
          font: {
            size: 11
          }
        }
      }
    },
    plugins: {
      title: {
        display: true,
        text: 'Franchise Performance',
        padding: {
          top: 10,
          bottom: 20
        },
        font: {
          size: 14,
          weight: 'bold'
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          font: {
            size: 11
          },
          padding: 10
        }
      },
      datalabels: {
        display: true,
        color: 'black',
        formatter: Math.round,
        anchor: 'end',
        offset: -20,
        align: 'start',
        font: {
          size: 10,
          weight: 'bold'
        }
      }
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderSkipped: false
      }
    },
    categoryPercentage: 0.7,
    barPercentage: 0.8
  }

  const chartOptionsForOutlet = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index'
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: true
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
          font: {
            size: 11
          }
        }
      },
      y: {
        beginAtZero: true,
        display: true,
        ticks: {
          font: {
            size: 11
          }
        }
      }
    },
    plugins: {
      title: {
        display: true,
        text: 'Outlet Performance',
        padding: {
          top: 10,
          bottom: 20
        },
        font: {
          size: 14,
          weight: 'bold'
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          font: {
            size: 11
          },
          padding: 10
        }
      },
      datalabels: {
        display: true,
        color: 'black',
        formatter: Math.round,
        anchor: 'end',
        offset: -20,
        align: 'start',
        font: {
          size: 10,
          weight: 'bold'
        }
      }
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderSkipped: false
      }
    },
    categoryPercentage: 0.7,
    barPercentage: 0.8
  }

  var convert = function (str) {
    var date = new Date(str)
    var mnth = `0${date.getMonth() + 1}`.slice(-2)
    var day = `0${date.getDate()}`.slice(-2)
    return [day, mnth, date.getFullYear()].join('-')
  }

  const { userFetchById, userFetchByIdData } = useFetchUserById()
  const [dailogOpen, setDailogOpen] = useState(false)
  const { logoutUser } = useLogout()
  const [subBusinessChartData, setSubBusinessChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Total Sales',
        data: [0],
        backgroundColor: ['#e0218a', '#2a71d0', '#ffbb11', '#f59c1a']
      }
    ]
  })
  const [outletChartData, setOutletChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Total Sales',
        data: [0],
        backgroundColor: ['#e0218a', '#2a71d0', '#ffbb11', '#f59c1a']
      }
    ]
  })

  useEffect(() => {
    businessCheck(history)
    if (userType !== 'Owner') {
      userFetchById()
    }
    fetchEntitlement()
    fromDate = moment().subtract(6, 'days').format('YYYY-MM-DD')
    toDate = moment().add(1, 'days').format('YYYY-MM-DD')

    // Priority 1: Fetch franchise and outlet data first
    if (userType === 'Owner') {
      const franchisePayload = {
        from_date: moment().format('YYYY-MM-DD'),
        to_date: moment().add(1, 'days').format('YYYY-MM-DD'),
        by_business_name: true,
        pageNumber: 1,
        limit: 5 // Reduced limit for faster loading
      }
      franchiseSummaryFetch(franchisePayload)
    }
    outletwiseSummaryFetch()

    // Priority 2: Fetch other essential data after franchise/outlet
    const essentialDataTimer = setTimeout(() => {
      fetchCurrent()
      const payload = {
        from_date: fromDate,
        to_date: toDate
      }
      fetchWeekly(payload)
      fetchBusinessByApplication()
    }, 100) // Short delay to prioritize franchise/outlet

    const intervalId = setInterval(() => {
      // Fetch current and weekly data
      fetchCurrent()
      const payload = {
        from_date: fromDate,
        to_date: toDate
      }
      fetchWeekly(payload)

      // Fetch all franchise/outlet data on every refresh
      if (userType === 'Owner') {
        const franchisePayload = {
          from_date: moment().format('YYYY-MM-DD'),
          to_date: moment().add(1, 'days').format('YYYY-MM-DD'),
          by_business_name: true,
          pageNumber: 1,
          limit: 5
        }
        franchiseSummaryFetch(franchisePayload)
      }
      outletwiseSummaryFetch()

      // Also refresh business application data
      fetchBusinessByApplication()
    }, 120 * 1000) // 2 minutes

    return () => {
      clearTimeout(essentialDataTimer)
      clearInterval(intervalId)
    }
  }, [])

  useEffect(() => {
    if (Object.keys(userFetchByIdData)?.length > 0) {
      if (userFetchByIdData?.outlet?.length === 0 && userType !== 'Owner') {
        setDailogOpen(true)
      }
    }
  }, [userFetchByIdData])

  useEffect(() => {
    if (Object.keys(fetchEntitlementData)?.length > 0) {
      let expiryingDate = new Date(fetchEntitlementData.expiry_date)
      if (expiryingDate < curDate) {
        setIsExpired(true)
      } else if (
        expiryingDate.getTime() - curDate.getTime() <=
        30 * 24 * 60 * 60 * 1000
      ) {
        setIsExpired(false)
      } else setIsExpired(null)
    }
  }, [fetchEntitlementData])

  useEffect(() => {
    if (currentLoading != true) {
      if (currentData.length <= 0) {
        setCurrentDateData([
          {
            Record_Date: moment().format('YYYY-MM-DD'),
            Total_Bills: 0,
            Total_Cess: 0.0,
            Total_Disc: 0.0,
            Total_GST: 0.0,
            Total_Sales: 0.0,
            Total_Qty: 0
          }
        ])
      } else {
        setCurrentDateData(currentData)
      }
    }
  }, [currentData])

  useEffect(() => {
    if (weeklyLoading != true) {
      if (weeklyData.length <= 0) {
        setdailySalesChartData({
          labels: [moment().format('MMM-DD')],
          datasets: [
            {
              label: 'Total Sales',
              data: [0],
              backgroundColor: ['#ffbb11']
            }
          ]
        })
        setdailyBillsChartData({
          labels: [moment().format('MMM-DD')],
          datasets: [
            {
              label: 'Total Invoice',
              data: [0],
              backgroundColor: ['#2a71d0']
            }
          ]
        })
      } else {
        // Sort data by date to ensure chronological order
        const sortedData = [...weeklyData].sort(
          (a, b) =>
            moment(a['Record_Date']).valueOf() -
            moment(b['Record_Date']).valueOf()
        )

        setdailySalesChartData({
          labels: sortedData.map((data) =>
            moment(data['Record_Date'], 'YYYY-MM-DD').format('MMM-DD')
          ),
          datasets: [
            {
              label: 'Total Sales',
              data: sortedData.map((data) => {
                return data['Total_Sales']
              }),
              backgroundColor: sortedData.map(
                (_, index) =>
                  `hsl(${(index * 360) / sortedData.length}, 70%, 50%)`
              )
            }
          ]
        })
        setdailyBillsChartData({
          labels: sortedData.map((data) =>
            moment(data['Record_Date'], 'YYYY-MM-DD').format('MMM-DD')
          ),
          datasets: [
            {
              label: 'Total Invoices',
              data: sortedData.map((data) => {
                return data['Total_Bills']
              }),
              backgroundColor: sortedData.map(
                (_, index) =>
                  `hsl(${(index * 360) / sortedData.length + 180}, 70%, 50%)`
              )
            }
          ]
        })
      }
    }
  }, [weeklyData])

  useEffect(() => {
    if (franchiseSummaryData?.data?.length > 0) {
      setSubBusinessChartData({
        labels: franchiseSummaryData?.data?.map(
          (data) => data['Sub_Business_Name']
        ),
        datasets: [
          {
            label: 'Total Sales',
            data: franchiseSummaryData?.data?.map(
              (data) => data['Total_Sales']
            ),
            backgroundColor: ['#e0218a', '#2a71d0', '#ffbb11', '#f59c1a'],
            barThickness: 50
          }
        ]
      })
    }

    if (outletwiseSummaryData?.data?.length > 0) {
      setOutletChartData({
        labels: outletwiseSummaryData?.data?.map((data) => data['Outlet_Name']),
        datasets: [
          {
            label: 'Total Sales',
            data: outletwiseSummaryData?.data?.map((data) => {
              return data['Total_Sales']
            }),
            backgroundColor: ['#e0218a', '#2a71d0', '#ffbb11', '#f59c1a'],
            barThickness: 50
          }
        ]
      })
    }
  }, [franchiseSummaryData, outletwiseSummaryData])

  const MyCard3 = ({ isLoading, title, count, addRupeeSybol = false }) => {
    return (
      <MainCard content>
        <Stack>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" color="inherit">
            {addRupeeSybol ? '₹' : ''} {count ?? 0}
          </Typography>
        </Stack>
      </MainCard>
    )
  }

  MyCard3.propTypes = {
    isLoading: PropTypes.bool,
    title: PropTypes.string,
    count: PropTypes.string,
    addRupeeSybol: PropTypes.bool
  }

  MyCard3.defaultProps = {
    color: 'primary'
  }
  const onOkPressed = () => {
    setDailogOpen(false)
    history('/auth/sign-in')
    logoutUser()
  }

  const BusinessDashboard = ({
    data,
    showSubBusiness = false,
    cardCount = 3
  }) => {
    return (
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
          '& > *': {
            maxWidth: '100%',
            overflow: 'hidden'
          }
        }}
      >
        <CardCarousel
          cards={data?.map((business, index) => (
            <Card
              key={index}
              sx={{
                width: '100%',
                maxWidth: '100%',
                minWidth: 'unset',
                background: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                  transform: 'translateY(-2px)'
                }
              }}
            >
              <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                {/* Title Section */}
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: '#2C3E50',
                      fontSize: '1rem',
                      letterSpacing: '-0.01em',
                      mb: 0.25
                    }}
                  >
                    {business?.Outlet_Name !== undefined
                      ? business?.Outlet_Name
                      : business?.Sub_Business_Name}
                  </Typography>

                  {showSubBusiness && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#546E7A',
                        fontSize: '0.8125rem',
                        fontWeight: 400
                      }}
                    >
                      {business?.Sub_Business_Name}
                    </Typography>
                  )}
                </Box>

                {/* Main Stats */}
                <Grid container spacing={2} sx={{ mb: 1.5 }}>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        py: 1,
                        px: 1.5,
                        backgroundColor: 'rgba(0, 102, 255, 0.08)',
                        borderRadius: '8px',
                        border: '1px solid rgba(0, 102, 255, 0.15)'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.6875rem',
                          fontWeight: 400,
                          color: '#666666',
                          display: 'block',
                          mb: 0.5
                        }}
                      >
                        Total Bills
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          fontSize: '1.25rem',
                          color: '#0066FF'
                        }}
                      >
                        {business?.Total_Bills}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        py: 1,
                        px: 1.5,
                        backgroundColor: 'rgba(0, 200, 83, 0.08)',
                        borderRadius: '8px',
                        border: '1px solid rgba(0, 200, 83, 0.15)'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.6875rem',
                          fontWeight: 400,
                          color: '#666666',
                          display: 'block',
                          mb: 0.5
                        }}
                      >
                        Total Sales
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          fontSize: '1.25rem',
                          color: '#00C853'
                        }}
                      >
                        ₹{business?.Total_Sales.toLocaleString()}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                {/* Secondary Stats */}
                <Grid container spacing={1.5}>
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        py: 1,
                        px: 1.5,
                        backgroundColor: 'rgba(156, 39, 176, 0.08)',
                        borderRadius: '8px',
                        border: '1px solid rgba(156, 39, 176, 0.15)'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.6875rem',
                          color: '#666666',
                          fontWeight: 400,
                          display: 'block',
                          mb: 0.5
                        }}
                      >
                        GST
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#9C27B0',
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}
                      >
                        ₹{business?.Total_GST.toLocaleString()}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        py: 1,
                        px: 1.5,
                        backgroundColor: 'rgba(255, 111, 0, 0.08)',
                        borderRadius: '8px',
                        border: '1px solid rgba(255, 111, 0, 0.15)'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.6875rem',
                          color: '#666666',
                          fontWeight: 400,
                          display: 'block',
                          mb: 0.5
                        }}
                      >
                        Cess
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#FF6F00',
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}
                      >
                        ₹{business?.Total_Cess.toLocaleString()}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        py: 1,
                        px: 1.5,
                        backgroundColor: 'rgba(211, 47, 47, 0.08)',
                        borderRadius: '8px',
                        border: '1px solid rgba(211, 47, 47, 0.15)'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.6875rem',
                          color: '#666666',
                          fontWeight: 400,
                          display: 'block',
                          mb: 0.5
                        }}
                      >
                        Discount
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#D32F2F',
                          fontWeight: 600,
                          fontSize: '0.875rem'
                        }}
                      >
                        ₹{business?.Total_Disc.toLocaleString()}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
          autoSlideDuration={10000}
          cardCount={cardCount}
          hideArrows={false}
          showIndicators={true}
          pauseOnHover={true}
        />
      </Box>
    )
  }

  const BusinessDashboard2 = () => {
    return (
      <Box
        sx={{
          width: '100%',
          minHeight: '100vh',
          p: { xs: 0.5, sm: 1, md: 2 },
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          maxWidth: 'calc(100vw - 300px)', // Account for sidebar width with more padding
          '@media (max-width: 960px)': {
            maxWidth: '100vw' // Full width on mobile when sidebar is collapsed
          }
        }}
      >
        <Helmet title="Dashboard" />
        {isExpired && (
          <Marquee style={{ color: '#D21312' }} speed="150" gradient={false}>
            <Typography variant="h5" gutterBottom>
              {' '}
              Your plan has expired as of{' '}
              {convert(fetchEntitlementData?.expiry_date)}
            </Typography>
          </Marquee>
        )}
        {isExpired === false && isExpired != null && (
          <Marquee style={{ color: '#E86A33' }} speed="150" gradient={false}>
            <Typography variant="h5" gutterBottom>
              Your subscription plan will expire on{' '}
              {convert(fetchEntitlementData?.expiry_date)}
            </Typography>
          </Marquee>
        )}

        {/* Business Sales Summary */}
        {currentLoading ? (
          <Box
            sx={{
              mb: { xs: 3, sm: 4 },
              px: { xs: 0.5, sm: 1 },
              pb: { xs: 2, sm: 3 }
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: { xs: 0.5, sm: 1 },
                fontSize: { xs: '1rem', sm: '1.25rem' },
                px: { xs: 0.5, sm: 0 },
                color: '#2C3E50',
                fontWeight: 600
              }}
            >
              Business Sales
            </Typography>
            <Card
              sx={{
                width: '100%',
                maxWidth: '540px',
                background: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                minHeight: 'auto'
              }}
            >
              <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                <Skeleton
                  variant="text"
                  width="70%"
                  height={24}
                  sx={{ mb: 1.5 }}
                />
                <Grid container spacing={2} sx={{ mb: 1.5 }}>
                  <Grid item xs={6}>
                    <Box sx={{ py: 0.5 }}>
                      <Skeleton
                        variant="text"
                        width="60%"
                        height={14}
                        sx={{ mb: 0.5 }}
                      />
                      <Skeleton variant="text" width="40%" height={20} />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box sx={{ py: 0.5 }}>
                      <Skeleton
                        variant="text"
                        width="60%"
                        height={14}
                        sx={{ mb: 0.5 }}
                      />
                      <Skeleton variant="text" width="50%" height={20} />
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={1.5}>
                  <Grid item xs={4}>
                    <Box sx={{ py: 0.5 }}>
                      <Skeleton
                        variant="text"
                        width="50%"
                        height={14}
                        sx={{ mb: 0.5 }}
                      />
                      <Skeleton variant="text" width="45%" height={16} />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box sx={{ py: 0.5 }}>
                      <Skeleton
                        variant="text"
                        width="50%"
                        height={14}
                        sx={{ mb: 0.5 }}
                      />
                      <Skeleton variant="text" width="35%" height={16} />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box sx={{ py: 0.5 }}>
                      <Skeleton
                        variant="text"
                        width="50%"
                        height={14}
                        sx={{ mb: 0.5 }}
                      />
                      <Skeleton variant="text" width="35%" height={16} />
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        ) : (
          currentDateData?.length > 0 && (
            <Box
              sx={{
                mb: { xs: 3, sm: 4 },
                px: { xs: 0.5, sm: 1 },
                pb: { xs: 2, sm: 3 }
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: { xs: 0.5, sm: 1 },
                  fontSize: { xs: '1rem', sm: '1.25rem' },
                  px: { xs: 0.5, sm: 0 },
                  color: '#2C3E50',
                  fontWeight: 600
                }}
              >
                Business Sales
              </Typography>
              <Card
                sx={{
                  width: '100%',
                  maxWidth: '540px',
                  background: '#ffffff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                    transform: 'translateY(-2px)'
                  }
                }}
              >
                <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                  {/* Title Section */}
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#2C3E50',
                        fontSize: '1rem',
                        letterSpacing: '-0.01em',
                        mb: 0.25
                      }}
                    >
                      {moment().format('MMMM DD, YYYY')}
                    </Typography>
                  </Box>

                  {/* Main Stats */}
                  <Grid container spacing={2} sx={{ mb: 1.5 }}>
                    <Grid item xs={6}>
                      <Box
                        sx={{
                          py: 1,
                          px: 1.5,
                          backgroundColor: 'rgba(0, 102, 255, 0.08)',
                          borderRadius: '8px',
                          border: '1px solid rgba(0, 102, 255, 0.15)'
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.6875rem',
                            fontWeight: 400,
                            color: '#666666',
                            display: 'block',
                            mb: 0.5
                          }}
                        >
                          Total Bills
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            color: '#0066FF'
                          }}
                        >
                          {currentDateData[0]?.Total_Bills || 0}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        sx={{
                          py: 1,
                          px: 1.5,
                          backgroundColor: 'rgba(0, 200, 83, 0.08)',
                          borderRadius: '8px',
                          border: '1px solid rgba(0, 200, 83, 0.15)'
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.6875rem',
                            fontWeight: 400,
                            color: '#666666',
                            display: 'block',
                            mb: 0.5
                          }}
                        >
                          Total Sales
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            color: '#00C853'
                          }}
                        >
                          ₹
                          {(
                            currentDateData[0]?.Total_Sales || 0
                          ).toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Secondary Stats */}
                  <Grid container spacing={1.5}>
                    <Grid item xs={4}>
                      <Box
                        sx={{
                          py: 1,
                          px: 1.5,
                          backgroundColor: 'rgba(156, 39, 176, 0.08)',
                          borderRadius: '8px',
                          border: '1px solid rgba(156, 39, 176, 0.15)'
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.6875rem',
                            color: '#666666',
                            fontWeight: 400,
                            display: 'block',
                            mb: 0.5
                          }}
                        >
                          GST
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#9C27B0',
                            fontWeight: 600,
                            fontSize: '0.875rem'
                          }}
                        >
                          ₹
                          {(
                            currentDateData[0]?.Total_GST || 0
                          ).toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box
                        sx={{
                          py: 1,
                          px: 1.5,
                          backgroundColor: 'rgba(255, 111, 0, 0.08)',
                          borderRadius: '8px',
                          border: '1px solid rgba(255, 111, 0, 0.15)'
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.6875rem',
                            color: '#666666',
                            fontWeight: 400,
                            display: 'block',
                            mb: 0.5
                          }}
                        >
                          Cess
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#FF6F00',
                            fontWeight: 600,
                            fontSize: '0.875rem'
                          }}
                        >
                          ₹
                          {(
                            currentDateData[0]?.Total_Cess || 0
                          ).toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box
                        sx={{
                          py: 1,
                          px: 1.5,
                          backgroundColor: 'rgba(211, 47, 47, 0.08)',
                          borderRadius: '8px',
                          border: '1px solid rgba(211, 47, 47, 0.15)'
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '0.6875rem',
                            color: '#666666',
                            fontWeight: 400,
                            display: 'block',
                            mb: 0.5
                          }}
                        >
                          Discount
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#D32F2F',
                            fontWeight: 600,
                            fontSize: '0.875rem'
                          }}
                        >
                          ₹
                          {(
                            currentDateData[0]?.Total_Disc || 0
                          ).toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          )
        )}

        {userType === 'Owner' &&
          (franchiseLoading ? (
            <Box sx={{ mb: { xs: 1, sm: 2 } }}>
              <Typography
                variant="h6"
                sx={{
                  mb: { xs: 0.5, sm: 1 },
                  fontSize: { xs: '1rem', sm: '1.25rem' },
                  px: { xs: 0.5, sm: 0 },
                  color: '#2C3E50',
                  fontWeight: 600
                }}
              >
                Franchise Network
              </Typography>
              <Box
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  overflow: 'hidden'
                }}
              >
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={12} sm={4} key={item}>
                      <Card
                        sx={{
                          background: '#ffffff',
                          border: '1px solid #e0e0e0',
                          borderRadius: '12px',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                          minHeight: '200px'
                        }}
                      >
                        <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                          <Skeleton
                            variant="text"
                            width="70%"
                            height={24}
                            sx={{ mb: 1.5 }}
                          />
                          <Grid container spacing={1.5} sx={{ mb: 1 }}>
                            <Grid item xs={6}>
                              <Box sx={{ py: 0.5 }}>
                                <Skeleton
                                  variant="text"
                                  width="60%"
                                  height={14}
                                  sx={{ mb: 0.5 }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="40%"
                                  height={20}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box sx={{ py: 0.5 }}>
                                <Skeleton
                                  variant="text"
                                  width="60%"
                                  height={14}
                                  sx={{ mb: 0.5 }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="50%"
                                  height={20}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                          <Grid container spacing={1.5}>
                            <Grid item xs={4}>
                              <Box sx={{ py: 0.5 }}>
                                <Skeleton
                                  variant="text"
                                  width="50%"
                                  height={14}
                                  sx={{ mb: 0.5 }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="45%"
                                  height={16}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box sx={{ py: 0.5 }}>
                                <Skeleton
                                  variant="text"
                                  width="50%"
                                  height={14}
                                  sx={{ mb: 0.5 }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="35%"
                                  height={20}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box sx={{ py: 0.5 }}>
                                <Skeleton
                                  variant="text"
                                  width="50%"
                                  height={14}
                                  sx={{ mb: 0.5 }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="35%"
                                  height={16}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          ) : (
            franchiseSummaryData?.data?.length > 0 && (
              <Box sx={{ mb: { xs: 1, sm: 2 } }}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: { xs: 0.5, sm: 1 },
                    fontSize: { xs: '1rem', sm: '1.25rem' },
                    px: { xs: 0.5, sm: 0 },
                    color: '#2C3E50',
                    fontWeight: 600
                  }}
                >
                  Franchise Network
                </Typography>
                <BusinessDashboard
                  data={franchiseSummaryData?.data}
                  cardCount={3}
                />
              </Box>
            )
          ))}
        {outletwiseLoading ? (
          <Box sx={{ mb: { xs: 1, sm: 2 } }}>
            <Typography
              variant="h6"
              sx={{
                mb: { xs: 0.5, sm: 1 },
                fontSize: { xs: '1rem', sm: '1.25rem' },
                px: { xs: 0.5, sm: 0 },
                color: '#2C3E50',
                fontWeight: 600
              }}
            >
              Outlet Matrix
            </Typography>
            <Box
              sx={{
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden'
              }}
            >
              <Grid container spacing={2}>
                {[1, 2, 3].map((item) => (
                  <Grid item xs={12} sm={4} key={item}>
                    <Card
                      sx={{
                        background: '#ffffff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                        minHeight: '200px'
                      }}
                    >
                      <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                        <Skeleton
                          variant="text"
                          width="75%"
                          height={24}
                          sx={{ mb: 1 }}
                        />
                        <Skeleton
                          variant="text"
                          width="60%"
                          height={18}
                          sx={{ mb: 1.5 }}
                        />
                        <Grid container spacing={1.5} sx={{ mb: 1 }}>
                          <Grid item xs={6}>
                            <Box sx={{ py: 0.5 }}>
                              <Skeleton
                                variant="text"
                                width="60%"
                                height={14}
                                sx={{ mb: 0.5 }}
                              />
                              <Skeleton
                                variant="text"
                                width="40%"
                                height={20}
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Box sx={{ py: 0.5 }}>
                              <Skeleton
                                variant="text"
                                width="60%"
                                height={14}
                                sx={{ mb: 0.5 }}
                              />
                              <Skeleton
                                variant="text"
                                width="50%"
                                height={20}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                        <Grid container spacing={1.5}>
                          <Grid item xs={4}>
                            <Box sx={{ py: 0.5 }}>
                              <Skeleton
                                variant="text"
                                width="50%"
                                height={14}
                                sx={{ mb: 0.5 }}
                              />
                              <Skeleton
                                variant="text"
                                width="45%"
                                height={16}
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box sx={{ py: 0.5 }}>
                              <Skeleton
                                variant="text"
                                width="50%"
                                height={14}
                                sx={{ mb: 0.5 }}
                              />
                              <Skeleton
                                variant="text"
                                width="35%"
                                height={16}
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box sx={{ py: 0.5 }}>
                              <Skeleton
                                variant="text"
                                width="50%"
                                height={14}
                                sx={{ mb: 0.5 }}
                              />
                              <Skeleton
                                variant="text"
                                width="35%"
                                height={20}
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box sx={{ py: 0.5 }}>
                              <Skeleton
                                variant="text"
                                width="50%"
                                height={14}
                                sx={{ mb: 0.5 }}
                              />
                              <Skeleton
                                variant="text"
                                width="35%"
                                height={16}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        ) : (
          outletwiseSummaryData?.data?.length > 0 && (
            <Box sx={{ mb: { xs: 1, sm: 2 } }}>
              <Typography
                variant="h6"
                sx={{
                  mb: { xs: 0.5, sm: 1 },
                  fontSize: { xs: '1rem', sm: '1.25rem' },
                  px: { xs: 0.5, sm: 0 },
                  color: '#2C3E50',
                  fontWeight: 600
                }}
              >
                Outlet Matrix
              </Typography>
              <BusinessDashboard
                data={outletwiseSummaryData?.data}
                showSubBusiness
                cardCount={3}
              />
            </Box>
          )
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1, sm: 1.5, md: 2, lg: 3 },
            width: '100%',
            maxWidth: 'calc(100vw - 300px)', // Account for sidebar width with more padding
            overflow: 'hidden',
            margin: '0 auto',
            '@media (max-width: 960px)': {
              maxWidth: '100%' // Full width on mobile when sidebar is collapsed
            }
          }}
        >
          {franchiseLoading ? (
            <Box
              sx={{
                p: { xs: 0.5, sm: 1, md: 2 },
                borderRadius: 2,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                width: '100%',
                overflow: 'hidden',
                maxWidth: '100%'
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: { xs: 1, sm: 2 },
                  fontWeight: 600,
                  color: '#2C3E50',
                  pb: 1,
                  fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
                }}
              >
                📊 Franchise Performance
              </Typography>
              <Box sx={{ width: '100%', maxWidth: '100%' }}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  sx={{
                    borderRadius: 1,
                    height: { xs: 200, sm: 250, md: 300 }
                  }}
                />
              </Box>
            </Box>
          ) : (
            franchiseSummaryData?.data?.length > 1 && (
              <Box
                sx={{
                  p: { xs: 0.5, sm: 1, md: 2 },
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  width: '100%',
                  overflow: 'hidden',
                  maxWidth: '100%'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mb: { xs: 1, sm: 2 },
                    fontWeight: 600,
                    color: '#2C3E50',
                    pb: 1,
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
                  }}
                >
                  📊 Franchise Performance
                </Typography>
                <Box
                  sx={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    '& > *': {
                      maxWidth: '100% !important',
                      width: '100% !important',
                      minWidth: '0 !important'
                    },
                    '& canvas': {
                      maxWidth: '100% !important',
                      width: '100% !important',
                      minWidth: '0 !important'
                    }
                  }}
                >
                  <BarChart
                    chartData={subBusinessChartData}
                    options={{
                      ...chartOptionsForSubBusiness,
                      responsive: true,
                      maintainAspectRatio: false,
                      layout: {
                        padding: { left: 10, right: 10, top: 10, bottom: 10 }
                      },
                      plugins: {
                        ...chartOptionsForSubBusiness.plugins,
                        legend: {
                          ...chartOptionsForSubBusiness.plugins.legend,
                          maxWidth: '100%'
                        }
                      }
                    }}
                  />
                </Box>
              </Box>
            )
          )}
          {outletwiseLoading ? (
            <Box
              sx={{
                p: { xs: 0.5, sm: 1, md: 2 },
                borderRadius: 2,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                width: '100%',
                overflow: 'hidden',
                maxWidth: '100%'
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: { xs: 1, sm: 2 },
                  fontWeight: 600,
                  color: '#2C3E50',
                  pb: 1,
                  fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
                }}
              >
                🏪 Outlet Performance
              </Typography>
              <Box sx={{ width: '100%', maxWidth: '100%' }}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  sx={{
                    borderRadius: 1,
                    height: { xs: 200, sm: 250, md: 300 }
                  }}
                />
              </Box>
            </Box>
          ) : (
            outletwiseSummaryData?.data?.length > 1 && (
              <Box
                sx={{
                  p: { xs: 0.5, sm: 1, md: 2 },
                  borderRadius: 2,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'secondary.main',
                  width: '100%',
                  overflow: 'hidden',
                  maxWidth: '100%'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mb: { xs: 1, sm: 2 },
                    fontWeight: 600,
                    color: '#2C3E50',
                    pb: 1,
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
                  }}
                >
                  🏪 Outlet Performance
                </Typography>
                <Box
                  sx={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    '& > *': {
                      maxWidth: '100% !important',
                      width: '100% !important',
                      minWidth: '0 !important'
                    },
                    '& canvas': {
                      maxWidth: '100% !important',
                      width: '100% !important',
                      minWidth: '0 !important'
                    }
                  }}
                >
                  <BarChart
                    chartData={outletChartData}
                    options={{
                      ...chartOptionsForOutlet,
                      responsive: true,
                      maintainAspectRatio: false,
                      layout: {
                        padding: { left: 10, right: 10, top: 10, bottom: 10 }
                      },
                      plugins: {
                        ...chartOptionsForOutlet.plugins,
                        legend: {
                          ...chartOptionsForOutlet.plugins.legend,
                          maxWidth: '100%'
                        }
                      }
                    }}
                  />
                </Box>
              </Box>
            )
          )}
          <Box
            sx={{
              p: { xs: 0.5, sm: 1, md: 2 },
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'success.main',
              width: '100%',
              overflow: 'hidden',
              maxWidth: '100%'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: { xs: 1, sm: 2 },
                fontWeight: 600,
                color: 'success.main',
                borderBottom: '2px solid',
                borderColor: 'success.main',
                pb: 1,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}
            >
              💰 Sales Trend
            </Typography>
            {currentLoading ? (
              <Box sx={{ width: '100%', maxWidth: '100%' }}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={{ xs: 200, sm: 250, md: 300 }}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  '& > *': {
                    maxWidth: '100% !important',
                    width: '100% !important',
                    minWidth: '0 !important'
                  },
                  '& canvas': {
                    maxWidth: '100% !important',
                    width: '100% !important',
                    minWidth: '0 !important'
                  }
                }}
              >
                <BarChart
                  chartData={dailySalesChartData}
                  options={{
                    ...chartOptions,
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                      padding: { left: 10, right: 10, top: 10, bottom: 10 }
                    },
                    plugins: {
                      ...chartOptions.plugins,
                      legend: {
                        ...chartOptions.plugins.legend,
                        maxWidth: '100%'
                      }
                    }
                  }}
                />
              </Box>
            )}
          </Box>
          <Box
            sx={{
              p: { xs: 0.5, sm: 1, md: 2 },
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'info.main',
              width: '100%',
              overflow: 'hidden',
              maxWidth: '100%'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: { xs: 1, sm: 2 },
                fontWeight: 600,
                color: 'info.main',
                borderBottom: '2px solid',
                borderColor: 'info.main',
                pb: 1,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}
            >
              🧾 Invoice Trend
            </Typography>
            {weeklyLoading ? (
              <Box sx={{ width: '100%', maxWidth: '100%' }}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={{ xs: 200, sm: 250, md: 300 }}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  '& > *': {
                    maxWidth: '100% !important',
                    width: '100% !important',
                    minWidth: '0 !important'
                  },
                  '& canvas': {
                    maxWidth: '100% !important',
                    width: '100% !important',
                    minWidth: '0 !important'
                  }
                }}
              >
                <BarChart
                  chartData={dailyBillsChartData}
                  options={{
                    ...chartOptionsForInvoice,
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                      padding: { left: 10, right: 10, top: 10, bottom: 10 }
                    },
                    plugins: {
                      ...chartOptionsForInvoice.plugins,
                      legend: {
                        ...chartOptionsForInvoice.plugins.legend,
                        maxWidth: '100%'
                      }
                    }
                  }}
                />
              </Box>
            )}
          </Box>
        </Box>
        <ConfirmationDialog
          visibility={dailogOpen}
          title={'Info'}
          message={
            'You are not mapped to any outlets. Please contact your Business Owner or NGX Support team'
          }
          okText={'Ok'}
          onOk={onOkPressed}
          onOkColor={'primary'}
        />
      </Box>
    )
  }

  // Return the main dashboard component
  return <BusinessDashboard2 />
}

export default Default
